import React from 'react';
import './styles.scss';
import LogoImage from '../../../assets/bracLogoFullCut.png';

interface IconProps {
  image?: string;
  height?: number | string;
  width?: number | string;
  className?: string;
  styles?: React.CSSProperties;
  darkLogo: string;
  lightLogo: string;
  alt: string;
}

/**
 * Primary UI component for user interaction
 */

export function Logo({ lightLogo, darkLogo, alt }: IconProps) {
  return (
    <div className="flex justify-center items-center ">
      <div className="sm:block hidden ">
        <img className="dark:hidden block " src={lightLogo} alt={alt} />
        <img className="dark:block hidden" src={darkLogo} alt={alt} />
      </div>
      <a href="/">
        <img
          className="sm:hidden block mt-3 cursor-pointer"
          src={LogoImage}
          alt="basicLogo"
        />
      </a>
    </div>
  );
}

export default React.memo(Logo);
